import {useSelector} from 'react-redux';
import {Navigate} from 'react-router-dom';
import {useCeremonyRoute} from '@hooks/useCeremonyRoute';
import {CEREMONY_DECLINED_PATH, getCeremonyDeclinedPath} from '@constants/routes';
import {TRANSACTION_STATUSES} from '@constants/package';
import {selectTransaction, selectTransactionId} from '../signerUiSlice';

function getIsTransactionDeclined(status: string | null | undefined): boolean {
    if (!status) {
        return false;
    }

    return status.toLowerCase() === TRANSACTION_STATUSES.DECLINED;
}

export default function DeclinedInterceptor() {
    const ceremonyRoute = useCeremonyRoute() as any;
    const transaction = useSelector(selectTransaction);
    const transactionId = useSelector(selectTransactionId);

    const isAlreadyOnDeclinedPage = ceremonyRoute?.path === CEREMONY_DECLINED_PATH;
    const isDeclined = !isAlreadyOnDeclinedPage && getIsTransactionDeclined(transaction?.status);
    const redirectPath = transactionId ? getCeremonyDeclinedPath(transactionId) : null;

    if (isDeclined && redirectPath) {
        return <Navigate to={redirectPath} replace />;
    }

    return null;
}
